export default "__VITE_ASSET__BdKKyG4s__"